// extracted by css-extract-rspack-plugin
export default {"container":"_72b8b729","designsContainer":"_f25e69e8"};